/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppInsertCuepointYoutubeIntegrationCuepointsMutationRequest, WebAppInsertCuepointYoutubeIntegrationCuepointsMutationResponse, WebAppInsertCuepointYoutubeIntegrationCuepointsPathParams, WebAppInsertCuepointYoutubeIntegrationCuepoints401, WebAppInsertCuepointYoutubeIntegrationCuepoints403 } from "../models/WebAppInsertCuepointYoutubeIntegrationCuepoints";

export function getWebAppInsertCuepointYoutubeIntegrationCuepointsUrl(station: WebAppInsertCuepointYoutubeIntegrationCuepointsPathParams["station"]) {
  const res = { method: 'POST', url: `/web-app/v1/youtube-cuepoints/${station}` as const }
  return res
}

/**
 * @description Resolves channel and live video from station settings (with legacy youtubeChannelId fallback), optional body `liveVideoId`, and active live registry. `cueType` is always `cueTypeAd`.
 * @summary Insert an ad cuepoint for the station live broadcast
 * {@link /web-app/v1/youtube-cuepoints/:station}
 */
export async function webAppInsertCuepointYoutubeIntegrationCuepoints(station: WebAppInsertCuepointYoutubeIntegrationCuepointsPathParams["station"], data: WebAppInsertCuepointYoutubeIntegrationCuepointsMutationRequest, config: Partial<RequestConfig<WebAppInsertCuepointYoutubeIntegrationCuepointsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppInsertCuepointYoutubeIntegrationCuepointsMutationResponse, ResponseErrorConfig<WebAppInsertCuepointYoutubeIntegrationCuepoints401 | WebAppInsertCuepointYoutubeIntegrationCuepoints403>, WebAppInsertCuepointYoutubeIntegrationCuepointsMutationRequest>({ method : "POST", url : getWebAppInsertCuepointYoutubeIntegrationCuepointsUrl(station).url.toString(), data : requestData, ... requestConfig })
  return res.data
}